import React from "react";
import "./Rewards.css";
import Common_Back_Btn from "../../../common_components/common_back_btn/Common_Back_Btn";
import { faLeftRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun } from "@fortawesome/free-regular-svg-icons";
import { Table } from "react-bootstrap";
import { formatDate } from "../../../../utils/common";

function Rewards({ WalletHistory, pointSetup, user }) {
  const getExpiryDate = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return formatDate(d);
  };

  const checkRewardStatus = (createdAt, days) => {
    const createdDate = new Date(createdAt);
    const expiryDate = new Date(createdDate);
    expiryDate.setDate(createdDate.getDate() + days);

    const today = new Date();

    return today > expiryDate ? "invalid" : "valid";
  };
  return (
    <>
      <section className="My_rewards_container">
        {/* Back */}
        <Common_Back_Btn backText={"Back"} />

        {/* Page Title */}
        <h2 className="My_rewards_title">My Rewards</h2>

        {/* Reward Information */}
        <div className="My_rewards_info_box">
          <div className="My_rewards_info_heading">
            <span className="My_rewards_info_icon">
              <FontAwesomeIcon icon={faSun} />
            </span>
            Reward Information
          </div>

          <p className="My_rewards_balance">
            Your balance is <b> {user?.point} Coins </b>
          </p>

          <div className="My_rewards_section">
            <h3 className="My_rewards_section_title">HOW TO EARN COINS</h3>

            <p className="My_rewards_text">
              Coins will be added to your reward balance after you take certain
              activities. For example, every time you make a purchase you will
              earn points based on the price of products purchased.
            </p>

            <ul className="My_rewards_list">
              <li>
                <p className="My_rewards_text">
                  Each ₹{Number(pointSetup?.discount) * 2} spent for your order
                  will earn
                  <b> 2 Points </b>.
                </p>
              </li>
            </ul>
          </div>

          <div className="My_rewards_section">
            <h3 className="My_rewards_section_title">HOW TO SPEND COINS</h3>

            <p className="My_rewards_text">
              You can use Coins in your reward balance as discount for your
              future purchases at our store. Please note that redeeming to cash
              is not allowed.
            </p>

            <ul className="My_rewards_list">
              <li>
                <p className="My_rewards_text">
                  Each 1 Coins can be redeemed for{" "}
                  <b>₹{Number(pointSetup?.discount_amount) * 1}</b>.
                </p>
              </li>
            </ul>
          </div>

          {/* Recent Transactions */}
          <div className="My_rewards_recent">
            <div className="My_rewards_info_heading">
              <span className="My_rewards_recent_icon">
                <FontAwesomeIcon icon={faLeftRight} />
              </span>
              Recent Transactions
            </div>

            <div className="My_rewards_table_wrapper">
              <Table bordered responsive className="My_rewards_table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Title</th>
                    <th>Coins</th>
                    <th>Earning Date</th>
                    <th>Expiration Date</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {WalletHistory?.filter((val) => val?.type === "Credit")
                    ?.length > 0 ? (
                    WalletHistory.filter((val) => val?.type === "Credit").map(
                      (val, index) => {
                        const status = checkRewardStatus(
                          val?.createdAt,
                          Number(pointSetup?.expired_days) || 0,
                        );

                        return (
                          <tr key={val?.id || index}>
                            <td>{index + 1}</td>
                            <td>{val?.remark}</td>
                            <td>{val?.coin} Coins</td>
                            <td>{formatDate(val?.createdAt)}</td>

                            <td>
                              {getExpiryDate(
                                val?.createdAt,
                                Number(pointSetup?.expired_days) || 0,
                              )}
                            </td>

                            <td>
                              <span className={`My_rewards_status ${status}`}>
                                {status === "valid" ? "Valid" : "Invalid"}
                              </span>
                            </td>
                          </tr>
                        );
                      },
                    )
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        No history found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Rewards;
